// src/index.js
import React from "react";
import ReactDOM from 'react-dom/client';
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import { Provider } from "react-redux";
import { GoogleOAuthProvider } from '@react-oauth/google';
import store, { persistor } from "./store";
import { PersistGate } from 'redux-persist/integration/react'; // import PersistGate

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';

if (Capacitor.getPlatform() === 'android') {
  (async () => {
    try {
      await StatusBar.setOverlaysWebView({ overlay: false });
      await StatusBar.setBackgroundColor({ color: '#ffffff' });
      await StatusBar.setStyle({ style: Style.Dark });
    } catch {}
  })();
}

/*---- Error and Warning handlings ----*/

// Temporary suppression of defaultProps warning
const consoleError = console.error;
console.error = (message, ...args) => {
  if (typeof message === 'string' && 
    message.includes('Support for defaultProps will be removed')) {
    return;
  }
  consoleError(message, ...args);
};
// Override console.warn to suppress specific warnings
const originalWarn = console.warn;
console.warn = (message, ...args) => {
  // Check if the message contains the AudioContext or third-party cookie warning
  if (typeof message === 'string' 
    && message && (message?.includes('third-party cookie will be blocked') || 
        message?.includes('AudioContext was not allowed'))
  ) {
    return; // Suppress this specific warning
  }
  // Handle case where message is an object (React Refresh)
  if (typeof message === 'object' && message && message.toString().includes('AudioContext was not allowed')) {
    return; // Suppress the warning
  }
  // Otherwise, pass the warning through
  originalWarn.apply(console, [message, ...args]);
};

/*---- Error and Warning handlings ----*/

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
const render = () => {
  root.render(
    <Provider store={store}>
      {/* PersistGate delays the rendering of the app's UI until persisted state is rehydrated */}
      <PersistGate loading={<div>Loading persisted state...</div>} persistor={persistor}>
        <React.Fragment>
          <QueryClientProvider client={queryClient}>
            <BrowserRouter>
              <GoogleOAuthProvider clientId={process.env.GOOGLE_CLIENT_ID}>
                <App />
                <ReactQueryDevtools initialIsOpen={false} />
              </GoogleOAuthProvider>
            </BrowserRouter>
          </QueryClientProvider>
        </React.Fragment>
      </PersistGate>
    </Provider>
  );
};

render();

// Enable HMR
if (module.hot) {
  module.hot.accept('./App', () => {
    render();
  });
}

serviceWorker.unregister();
